// create context
import { createContext } from 'react';
import { EmailEditorActions, EmailEditorState } from './types';

export const EmailEditorStateContext = createContext<EmailEditorState | undefined>(undefined);

export const EmailEditorActionsContext = createContext<EmailEditorActions | undefined>(undefined);
